import PropTypes from "prop-types";
import React from "react";
import AccountMenu from "../../sections/account-menu";
import SimpleHero from "../../sections/simple-hero";
import "./style.scss";

export default function MyAccountTemplate({
  heroConfiguration,
  menu,
  children
}) {
  return (
    <div className="my-account-template grid">
      <SimpleHero {...heroConfiguration} />
      <AccountMenu {...menu} />
      {children}
    </div>
  );
}

MyAccountTemplate.propTypes = {
  heroConfiguration: PropTypes.object,
  menu: PropTypes.object,
  children: PropTypes.node
};
